const Resources = {
    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
    ],

    table_headers: [
        {
            text:   'Daily Task',
            value:  'task_name',
            report_value: 'task_name',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Floor',
            value:  'floor_name',
            report_value: 'floor_name',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Task',
            value:  'secondary_task_name',
            report_value: 'secondary_task_name',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Frequency',
            value:  'frequency_number_day',
            report_value: 'frequency_number_day',
            type:   '',
            show: true,
            order: 0,
        },
    ]
}

export default Resources